module.exports = __webpack_public_path__ + "static/media/Sports.c78f7df9.svg";